import { type LiteClient, liteClient } from 'algoliasearch/lite'
import { useMemo } from 'react'

import { useAlgoliaConfigContext } from '../context/algoliaConfigContext'

export const useSearchClient = (): LiteClient => {
  const { algoliaApiKey, algoliaApplicationId } = useAlgoliaConfigContext()

  return useMemo(() => {
    return liteClient(algoliaApplicationId, algoliaApiKey)
  }, [algoliaApiKey, algoliaApplicationId])
}
